(() => {
  function setup(header) {
    if (header.dataset.enhanced) return;
    header.dataset.enhanced = 'true';
    const navigation = header.querySelector('[data-zt-navigation]');
    const menuToggle = header.querySelector('[data-zt-menu-toggle]');
    const disclosures = [...header.querySelectorAll('[data-zt-disclosure]')];
    const guidePanels = [...header.querySelectorAll('[data-zt-guides]')];
    const desktop = window.matchMedia('(min-width: 1024px)');
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    let openTimer;
    let closeTimer;
    const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };
    const close = (panel, restoreFocus = false) => {
      panel.open = false;
      panel.querySelector('summary').setAttribute('aria-expanded', 'false');
      if (!desktop.matches) panel.querySelectorAll('[data-zt-guides]').forEach(guides => { guides.open = false; });
      if (restoreFocus) panel.querySelector('summary').focus();
    };
    const closeAll = except => disclosures.forEach(panel => { if (panel !== except) close(panel); });
    function updateRail(carousel) {
      const rail = carousel.querySelector('[data-zt-rail]');
      const remaining = rail.scrollWidth - rail.clientWidth - rail.scrollLeft;
      carousel.querySelector('[data-zt-scroll="-1"]').setAttribute('aria-disabled', String(rail.scrollLeft <= 4));
      carousel.querySelector('[data-zt-scroll="1"]').setAttribute('aria-disabled', String(remaining <= 4));
      carousel.querySelector('.zt-mega__arrows').hidden = rail.scrollWidth <= rail.clientWidth + 2;
    }
    function changeViewport() {
      clearTimers();
      closeAll();
      menuToggle.hidden = desktop.matches;
      menuToggle.setAttribute('aria-expanded', 'false');
      navigation.hidden = !desktop.matches;
      guidePanels.forEach(panel => { panel.open = desktop.matches; });
    }
    desktop.addEventListener('change', changeViewport);
    changeViewport();
    menuToggle.addEventListener('click', () => {
      navigation.hidden = !navigation.hidden;
      menuToggle.setAttribute('aria-expanded', String(!navigation.hidden));
      if (navigation.hidden) closeAll();
    });
    disclosures.forEach(panel => {
      panel.querySelector('summary').addEventListener('click', clearTimers);
      panel.addEventListener('toggle', () => {
        panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
        if (panel.open) {
          closeAll(panel);
          panel.querySelectorAll('[data-zt-carousel]').forEach(updateRail);
        }
      });
      panel.addEventListener('pointerenter', event => {
        if (!desktop.matches || !hover.matches || event.pointerType === 'touch') return;
        clearTimers();
        openTimer = setTimeout(() => { closeAll(panel); panel.open = true; }, 350);
      });
      panel.addEventListener('pointerleave', () => {
        clearTimers();
        if (desktop.matches && !panel.contains(document.activeElement)) closeTimer = setTimeout(() => close(panel), 200);
      });
      panel.querySelector('[data-zt-panel-close]').addEventListener('click', () => { clearTimers(); close(panel, true); });
    });
    header.querySelectorAll('[data-zt-carousel]').forEach(carousel => {
      const rail = carousel.querySelector('[data-zt-rail]');
      rail.addEventListener('scroll', () => updateRail(carousel), { passive: true });
      carousel.querySelectorAll('[data-zt-scroll]').forEach(button => button.addEventListener('click', () => {
        if (button.getAttribute('aria-disabled') === 'true') return;
        rail.scrollBy({ left: rail.clientWidth * Number(button.dataset.ztScroll), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
    });
    document.addEventListener('click', event => {
      if (!navigation.contains(event.target) && !menuToggle.contains(event.target)) {
        clearTimers(); closeAll();
        if (!desktop.matches) { navigation.hidden = true; menuToggle.setAttribute('aria-expanded', 'false'); }
      }
    });
    document.addEventListener('focusin', event => {
      if (desktop.matches) disclosures.forEach(panel => { if (!panel.contains(event.target)) close(panel); });
    });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      clearTimers();
      const activeGuides = event.target.closest('[data-zt-guides][open]');
      if (!desktop.matches && activeGuides) {
        activeGuides.open = false; activeGuides.querySelector('summary').focus(); event.preventDefault(); return;
      }
      const activePanel = event.target.closest('[data-zt-disclosure][open]');
      if (activePanel) { close(activePanel, true); event.preventDefault(); }
      else if (!desktop.matches && !navigation.hidden) {
        closeAll(); navigation.hidden = true; menuToggle.setAttribute('aria-expanded', 'false'); menuToggle.focus(); event.preventDefault();
      } else closeAll();
    });
    // Empire bridges its private jQuery event after successful cart writes.
    window.addEventListener('zolaterra:cart-count-updated', event => {
      if (!header.isConnected) return;
      const count = event.detail?.item_count;
      if (!Number.isInteger(count)) return;
      header.querySelectorAll('[data-zt-cart-count]').forEach(badge => { badge.textContent = count; badge.hidden = count === 0; });
    });
  }
  document.querySelectorAll('[data-zt-header]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-zt-header]').forEach(setup));
})();
